var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"bgc_aux_unknown float-right",attrs:{"disabled":!_vm.editAllowed},on:{"click":_vm.showDeliveries}},[_c('h3',[_vm._v(_vm._s(_vm.giveEvents))])])
}
var staticRenderFns = []

export { render, staticRenderFns }